import React, { createContext, useCallback, useContext, useState } from "react";
import { BookingModal } from "../components/BookingModal";
type BookingContextValue = {
  openBooking: () => void;
};
const BookingContext = createContext<BookingContextValue | null>(null);
export function BookingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const openBooking = useCallback(() => setOpen(true), []);
  const closeBooking = useCallback(() => setOpen(false), []);
  return <BookingContext.Provider value={{
    openBooking
  }} data-id="element-287" data-mp="1ywh4b5fe5aw7">
      {children}
      <BookingModal open={open} onClose={closeBooking} data-id="element-288" data-mp="2cvgrs9r63jqs" />
    </BookingContext.Provider>;
}
export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
}